import { createAction, props } from '@ngrx/store';
import { UserModel } from 'src/app/modules/shared/model/userModel.model';

export const loadUserModels = createAction(
  '[UserModel] Load UserModels',
  props<{LoggedInUser: UserModel}>()
);

export const loadUserModelsSuccess = createAction(
  '[UserModel] Load UserModels Success',
  props<{ data: any }>()
);

export const loadUserModelsFailure = createAction(
  '[UserModel] Load UserModels Failure',
  props<{ error: any }>()
);

export const addUserModels = createAction(
  '[UserModel] Add UserModels',
  props<{LoggedInUser: UserModel}>() 
);

export const addUserModelsSuccess = createAction(
  '[UserModel] Add UserModels Success',
  props<{ data: any }>()
);

export const addUserModelsFailure = createAction(
  '[UserModel] Add UserModels Failure',
  props<{ error: any }>()
);
